module.exports = "/_next/static/images/avatar_Lukas-40d1f434c198325369c42d23cb11e308.svg";